module.exports = __webpack_public_path__ + "media/img/pages/profile/zhaw ger 2-005728b0f5dc71aa4ab509a7f7a9662a.jpg";